module.exports = __webpack_public_path__ + "img/identifyCard.2e122a48.png";